/**
 * Recursos API para Cobros de Pagos Recurrentes
 */

/**
 * Mapear estado de cobro de API a formato frontend
 */
const mapChargeStatus = (status) => {
  if (!status) return 'pending';
  
  const normalizedStatus = status.toLowerCase();
  
  const statusMap = {
    'pending': 'pending',
    'processing': 'processing',
    'succeeded': 'succeeded',
    'failed': 'failed',
    'cancelled': 'cancelled',
    'pastdue': 'pastdue',
    'skippedzeroamount': 'skippedzeroamount',
    'skippednullamount': 'skippednullamount'
  };
  
  return statusMap[normalizedStatus] || status;
};

/**
 * Transformar datos de cobro de API a formato frontend
 */
/**
 * Mapear intento de cobro de API a formato frontend
 */
const mapChargeAttemptFromApi = (attempt) => {
  if (!attempt) return null;
  
  return {
    attemptId: attempt.attempt_id,
    attemptNumber: attempt.attempt_number,
    status: mapChargeStatus(attempt.status),
    amount: attempt.amount,
    currency: attempt.currency,
    referenceNumber: attempt.reference_number,
    failureReason: attempt.failure_reason,
    failureCode: attempt.failure_code,
    attemptedAt: attempt.attempted_at,
    processingTimeMs: attempt.processing_time_ms,
  };
};

export const mapChargeFromApi = (charge) => {
  if (!charge) return null;
  
  const attempts = Array.isArray(charge.attempts) 
    ? charge.attempts.map(mapChargeAttemptFromApi).filter(Boolean)
    : [];
  
  return {
    chargeId: charge.charge_id,
    subscriptionId: charge.subscription_id,
    amount: charge.amount,
    currency: charge.currency,
    status: mapChargeStatus(charge.status),
    referenceNumber: charge.reference_number,
    billingPeriodStart: charge.billing_period_start,
    billingPeriodEnd: charge.billing_period_end,
    attemptCount: charge.attempt_count,
    maxAttempts: charge.max_attempts,
    nextAttemptAt: charge.next_attempt_at,
    lastAttemptAt: charge.last_attempt_at,
    failureReason: charge.failure_reason,
    failureCode: charge.failure_code,
    createdAt: charge.created_at,
    updatedAt: charge.updated_at,
    customerName: charge.customer_name,
    customerEmail: charge.customer_email,
    planName: charge.plan_name,
    paymentMethodLast4: charge.payment_method_last4,
    paymentMethodBrand: charge.payment_method_brand,
    externalReference: charge.external_reference,
    attempts,
  };
};

/**
 * Obtener detalle de un cobro por ID
 */
export const getChargeById = (token) => (chargeId) => ({
  endpoint: `/api/v1/recurring-payments/charges/${chargeId}`,
  method: 'GET',
  headers: {
    'X-Authentication-Token': token,
  },
  cache: false,
  proxy: false,
  preserveErrorObject: true,
  parseResponse: (response) => {
    const charge = response.data?.data || {};
    return mapChargeFromApi(charge);
  },
});

/**
 * Obtener lista de cobros con paginación
 */
export const getCharges = (token) => (payload) => ({
  endpoint: '/api/v1/recurring-payments/charges',
  method: 'GET',
  params: payload,
  headers: {
    'X-Authentication-Token': token,
  },
  cache: false,
  proxy: false,
  preserveErrorObject: true,
  parseResponse: (response) => {
    const apiData = response.data?.data || {};
    const chargesArray = Array.isArray(apiData.data) ? apiData.data : (Array.isArray(apiData) ? apiData : []);
    const mappedData = chargesArray.map(mapChargeFromApi);
    
    return {
      data: mappedData,
      pagination: {
        total_count: parseInt(apiData.total_count) || parseInt(apiData.totalCount) || 0,
        limit: parseInt(apiData.limit) || 10,
        offset: parseInt(apiData.offset) || 0,
      },
    };
  },
});

export const exportChargesReport = (token) => (payload) => ({
  endpoint: '/api/v1/recurring-payments/reports/charges/export',
  method: 'GET',
  params: payload,
  headers: {
    'X-Authentication-Token': token,
  },
  proxy: false,
  responseType: 'blob',
});

